export function getServerUrl() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
          ? window.location.protocol + '//' + window.location.hostname + ':8080'
          : window.location.protocol + '//' + window.location.host;
}
